import { lazy } from "react";
// Administration Module
// Manages employees, locations, users, and roles

const AdministrationPage = lazy(() => import("./pages/AdministrationPage"));
export const administrationRoutes = [
  { path: "/administration", element: <AdministrationPage /> },
];

export { AdministrationPage };
